export default "__VITE_ASSET__DMbHs8RF__"